Ext.define('SA.view.RelatedDataViewToolbar', {
    extend: 'SA.view.Toolbar',

    initComponent() {
        var fill = {xtype: 'pvt-fill'},
            sortLabel = {xtype: 'pvt-text', text: 'sorted by'},
            typeLabelLeft = {xtype: 'pvt-text', text: 'and showing'},
            typeLabelRight = {xtype: 'pvt-text', text: 'data'},
            exportBtn = {xtype: 'pvt-export-button', margin: '0 10 0 0'},
            attributeCombo = {xtype: 'pvt-auto-refreshing-attribute-dropdown', projectView: this.model},
            sortCombo = this.getSortCombo(),
            typeCombo = this.getTypeCombo(),
            viewActionsCombo = SA.view.ViewActionsMenuBuilder.build({projectView: this.model});

        this.items = [attributeCombo, sortLabel, sortCombo, typeLabelLeft, typeCombo, typeLabelRight, fill, viewActionsCombo, exportBtn];

        this.callParent();
    },

    getSortCombo() {
        var model = this.model;

        return {
            xtype: 'combo-button',
            emptyText: 'Data Variable',
            htmlEncode: false,
            menu: {defaults: {encodeText: false}},
            textTpl: '{.:locationRenderer}',
            ui: 'underline',

            listeners: {
                beforerender(cmp) {
                    cmp.refresh();

                    cmp.mon(model, 'change:location', cmp.refreshItems, cmp);
                    cmp.mon(model, 'change:sort', cmp.refresh, cmp);

                    cmp.mon(SA.data.LocationAliases, 'change', cmp.refreshText, cmp);
                }
            },

            buildItems() {
                var items = SA.data.LocationsCache.get(model.getLocations());

                return [null, '-', ...items];
            },

            refresh() {
                var locationSeries = model.getSortLocation(),
                    value = locationSeries ? SA.data.LocationsCache.get(locationSeries) : null;

                this.setValue(value);
            },

            selectHandler(location) {
                model.setSort(location);
                model.save();
            },

            updateText(location) {
                this.setText(location ? Ext.util.Format.locationRenderer({
                    locationAlias: location.locationAlias,
                    name: location.name
                }) : 'Data Variable');
            }
        };
    },

    getTypeCombo() {
        var model = this.model;

        return {
            xtype: 'combo-button',
            emptyText: 'All',
            ui: 'underline',

            listeners: {
                beforerender(cmp) {
                    cmp.refresh();

                    cmp.mon(model, {
                        'change:attribute': cmp.refreshItems,
                        'change:attributeTypeFilter': cmp.refresh,

                        scope: cmp
                    });
                }
            },

            buildItems() {
                var allowed = model.getAllowedAttributeFilterTypes(this.refreshItems, this),
                    current = model.getAttributeTypeFilter(),
                    items = [null, '-'];

                ['count', 'percent', 'mean', 'median'].forEach(type => {
                    if (current === type || allowed.includes(type)) {
                        items.push(type);
                    }
                });

                return items;
            },

            refresh() {
                this.setValue(model.getAttributeTypeFilter());
            },

            selectHandler(value) {
                model.setAttributeTypeFilter(value);
                model.save();
            }
        };
    }
});